import { createContext, useContext } from 'react';

import { Channel, MessageType } from '../../domain';

export type SubscribeToChannelsModalState = {
  subscribingToChannels: Channel[];
};

export type SubscribeToMessageTypesModalState = {
  subscribingToMessageTypes: MessageType[];
};

export type UnsubscribeFromChannelsModalState = {
  unsubscribingFromChannels: Channel[];
};

export type UnsubscribeFromMessageTypesModalState = {
  unsubscribingFromMessageTypes: MessageType[];
};

export type ModalState =
  | SubscribeToChannelsModalState
  | SubscribeToMessageTypesModalState
  | UnsubscribeFromChannelsModalState
  | UnsubscribeFromMessageTypesModalState;

type ModalContextState = {
  showModal: (modalState: ModalState) => void;
  hideModal: () => void;
  modalState?: ModalState;
};

const defaultState = {
  showModal: () => null,
  hideModal: () => null,
};

export const ModalsContext = createContext<ModalContextState>(defaultState);

export const useModalsContext = () => useContext(ModalsContext);
